<template>
  <div class="wrapper wrapper-content animated fadeIn">
    <div class="container">
      <h3>Agendas Tarifárias</h3>
      <div class="mail-box">
        <table class="table table-hover table-mail">
          <thead class="table-head">
            <tr>
              <th>Nome</th>

              <th></th>
            </tr>
          </thead>

          <tbody class="table-list">
            <tr v-for="(schedule, key) in schedules" :key="key">
              <td>{{ schedule.name }}</td>
              <td class="list-command">
                <div class="form-check">
                  <input
                    type="checkbox"
                    class="form-check-input"
                    :value="schedule._id"
                    v-model="selectedSchedules"
                  />
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <form v-on:submit.prevent="relate">
        <button
          class="btn btn-block btn-primary compose-mail"
          href="mail_compose.html"
        >
          <i class="fa fa-save"></i>
          Relacionar agendas
        </button>
      </form>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
export default {
  data() {
    return {
      schedules: [],
      selectedSchedules: [],
    };
  },
  computed: {
    ...mapGetters({
      client: 'DATA-ACCESS/client',
    }),
  },

  mounted() {
    this.loadTariffSchedule();
    this.listClients();
  },
  methods: {
    async loadTariffSchedule() {
      try {
        const schedules = await this.$store.dispatch(
          'TARIFF-SCHEDULE/LoadTariffSchedules',
        );
        this.schedules = schedules;
        this.selectedSchedules = this.client.showSpotsBySchedules;
      } catch (error) {
        this.$toasted.error(error.error);
      }
    },
    async listClients() {
      try {
        const clients = await this.$store.dispatch('CLIENT/ListAll');
        this.clientsList = clients;
      } catch (error) {
        this.$toasted.error('Não foi possível listar os clientes');
      }
    },
    async relate() {
      try {
        await this.$store.dispatch('CLIENT/RelateSchedulesToListSpot', {
          schedules: this.selectedSchedules,
        });
        this.$toasted.success('Agenda(s) relacionada(s)');
        this.listClients();
      } catch (error) {
        this.$toasted.error('Não foi possível relacionar');
      }
    },
  },
};
</script>